import axios from 'axios';
import { BASEURL } from './constants';

const api = axios.create({
	baseURL: BASEURL,
	timeout: 180000,
});
// METHODS
export const get = (endpoint, jwt = null) => request('GET', endpoint, null, jwt);
export const post = (endpoint, data = null, jwt = null, additionalHeaders = {}) =>
	request('POST', endpoint, data, jwt, additionalHeaders);
export const patch = (endpoint, data = null, jwt) =>
	request('PATCH', endpoint, data, jwt);
export const put = (endpoint, data = null, jwt) =>
	request('PUT', endpoint, data, jwt);
export const del = (endpoint, jwt = null) => request('DELETE', endpoint, null, jwt);

const request = (method, endpoint, data = null, jwt = null, additionalHeaders = {}) => {

	const headers = {
		Accept: 'application/json',
		Authorization: '',
		...additionalHeaders
	};

	if (jwt) {
		if (jwt) {
			headers['Authorization'] = `Bearer ${jwt}`;
		}

	}
	return api({
		method,
		url: endpoint,
		data,
		headers,
	})
		.then((response) => {

			return response.data;
		})
		.catch((error) => {
			console.log('API THROW>>>>>>>', JSON.stringify(error, null, 2));
			return error.response;
		});
};